import { __ } from '../../../../i18n';

export function getLanguageOptions() {
  return [
    { text: __('English'), value: 'en', 'data-value': 'en' },
    { text: __('Spanish'), value: 'es', 'data-value': 'es' },
    { text: __('Portuguese'), value: 'pt', 'data-value': 'pt' },
  ];
}
